export default {"src":"/_next/static/media/greenbellpepper.e67a84f2.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};